/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Row, Col, FormGroup, Accordion, Card, Button, Table } from 'react-bootstrap';
import Select from 'react-select';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { cloneDeep, set } from 'lodash';
import { useFieldArray, useFormContext, Controller } from 'react-hook-form';
import { MultiSelect } from 'react-multi-select-component';
import { getPlacementOptions, getFinishedOptions, getAllBOMComponentOptions } from '../../store/SupplierSuggestion.action';
import Composition from './Composition';
import { transportArray, currencyCodes, convertSelectLabel } from '../../../../Components/helper';
import { commonPath } from '../../../DevlopmentOrder/Bom/BomProvider/filedPaths';
import CustomToggle from '../../../../Components/CustomToggle';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import BomSubType from '../../../Library/BomLibrary/bomSubType';
import BomProductImpact from '../../../Library/BomLibrary/BomProductImpact';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { fetchBomLibarayUnitOfMeasure, fetchBomReferenceType, fetchBomLibarayComposition } from '../../../Library/BomLibrary/store/BomLibrary.action';
import * as masterAction from '../../../SystemMasters/Store/SystemMasters.action';

function BomTypeForm({
  selectedBomType,
  componentType,
  compositionFromReducer,
  unitsFromReducer,
  selectedType,
  removeSelectedBomComponent,
  placementOptions,
  finishedOptions,
  getPlacementOptions,
  getFinishedOptions,
  bomSubComponentOptions,
  getAllBOMComponentOptions,
  fetchBomReferenceType,
  fetchBomLibarayUnitOfMeasure,
  fetchBomLibarayComposition,
  getCompositionProcessDetails,
  customAttributeBomList,
  defaultDynamicColumns,
  supplierOptions,
  fromLibrary,
  userInfo,
  suppliers,
}) {
  const { control, register, errors, fields, setValue, append, isValid, clearErrors, trigger, disabledSubmitButton, suggestionEditMode, getValues, watch } =
    useFormContext();

  useFieldArray({
    control,
    name: 'bomForm',
  });

  const bomForm = watch('bomForm');

  const { t } = useTranslation('common');

  const [additionalInfoCount, setAdditionalInfoCount] = useState({});
  const [descCount, setDescCount] = useState({});

  const [compositionList, setCompositionList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [multiPlacementOptions, setMultiPlacementOptions] = useState([]);

  const currencyOptions = useMemo(() => {
    return currencyCodes?.map((currKey) => convertSelectLabel(currKey, true));
  }, [currencyCodes?.length]);

  // Sub-BOM state management per BOM form item
  const [activeKeys, setActiveKeys] = useState({});
  const [columnHeaders, setColumnHeaders] = useState({});
  const [compositionErrors, setCompositionErrors] = useState({});
  const [bomDeletedData, setBomDeletedData] = useState({});
  const [productImpactActiveKeys, setProductImpactActiveKeys] = useState({});
  const bomProductImpactRefs = useRef({});
  const previousCompositionIdsRef = useRef([]);
  const initialCompositionProcessedRef = useRef(false);

  const handleCompositionChange = useCallback(() => {
    if (!fields || fields.length === 0 || !selectedBomType?._id || !userInfo?.userId) return;

    const compositionIds = [];
    fields.forEach((_, index) => {
      const compositionArray = getValues(`bomForm[${index}].composition`);
      if (compositionArray && Array.isArray(compositionArray)) {
        compositionArray.forEach((compItem) => {
          if (compItem?.composition?._id) {
            compositionIds.push(compItem.composition._id);
          } else if (compItem?.composition && typeof compItem.composition === 'string') {
            compositionIds.push(compItem.composition);
          }
        });
      }
    });

    const uniqueCompositionIds = [...new Set(compositionIds)].sort().join(',');
    const previousIds = previousCompositionIdsRef.current.sort().join(',');

    if (uniqueCompositionIds !== previousIds && compositionIds.length > 0) {
      previousCompositionIdsRef.current = [...new Set(compositionIds)];
      const params = {
        loggedInUserId: userInfo.userId,
        bomTypeId: selectedBomType._id,
        compositionMasterIds: previousCompositionIdsRef.current,
      };
      getCompositionProcessDetails(params);
    } else if (compositionIds.length === 0 && previousCompositionIdsRef.current.length > 0) {
      previousCompositionIdsRef.current = [];
    }
  }, [fields, selectedBomType?._id, userInfo?.userId, getCompositionProcessDetails, getValues]);

  useEffect(() => {
    initialCompositionProcessedRef.current = false;
    previousCompositionIdsRef.current = [];
  }, [selectedBomType?._id]);

  useEffect(() => {
    if (!fields || fields.length === 0 || !selectedBomType?._id || !userInfo?.userId) return;
    if (initialCompositionProcessedRef.current) return;

    const compositionIds = [];
    fields.forEach((_, index) => {
      const compositionArray = getValues(`bomForm[${index}].composition`);
      if (compositionArray && Array.isArray(compositionArray)) {
        compositionArray.forEach((compItem) => {
          if (compItem?.composition?._id) {
            compositionIds.push(compItem.composition._id);
          } else if (compItem?.composition && typeof compItem.composition === 'string') {
            compositionIds.push(compItem.composition);
          }
        });
      }
    });

    if (compositionIds.length > 0) {
      const uniqueCompositionIds = [...new Set(compositionIds)];
      const uniqueCompositionIdsString = uniqueCompositionIds.sort().join(',');
      const previousIdsString = previousCompositionIdsRef.current.sort().join(',');

      if (uniqueCompositionIdsString !== previousIdsString) {
        previousCompositionIdsRef.current = uniqueCompositionIds;
        initialCompositionProcessedRef.current = true;
        const params = {
          loggedInUserId: userInfo.userId,
          bomTypeId: selectedBomType._id,
          compositionMasterIds: previousCompositionIdsRef.current,
        };
        getCompositionProcessDetails(params);
      }
    }
  }, [fields, selectedBomType?._id, userInfo?.userId, getCompositionProcessDetails, getValues]);

  useEffect(() => {
    disabledSubmitButton(false);
    return () => {
      disabledSubmitButton(true);
    };
  }, []);

  useEffect(() => {
    if (placementOptions && placementOptions?.length > 0) {
      const placementData = placementOptions?.map((item) => ({
        label: item.name,
        value: item._id,
      }));
      setMultiPlacementOptions(placementData);
    }
  }, [placementOptions]);

  useEffect(() => {
    setCompositionList(compositionFromReducer);
  }, [compositionFromReducer]);

  useEffect(() => {
    setUnitList(unitsFromReducer);
  }, [unitsFromReducer]);

  useEffect(() => {
    setUnitList(unitsFromReducer);
  }, [unitsFromReducer]);

  useEffect(() => {
    async function callOptions() {
      await Promise.all([
        getPlacementOptions({ isActive: true, bomTypeId: selectedBomType?._id }),
        getFinishedOptions({ isActive: true }),
        getAllBOMComponentOptions(),
        fetchBomReferenceType({ bomTypeId: selectedBomType?._id }),
        fetchBomLibarayUnitOfMeasure({ isActive: true }),
        fetchBomLibarayComposition({ isActive: 1, bomTypeId: selectedBomType?._id, loggedInUserId: userInfo?.userId }),
      ]);
    }
    callOptions();
  }, [selectedBomType?._id]);

  // Sync product impact state to form whenever accordion closes or periodically
  useEffect(() => {
    const syncProductImpactToForm = () => {
      Object.keys(bomProductImpactRefs.current).forEach((index) => {
        const ref = bomProductImpactRefs.current[index];
        if (ref && typeof ref.getBomImpactLocalState === 'function') {
          try {
            const productImpactState = ref.getBomImpactLocalState();
            if (productImpactState) {
              setValue(`bomForm[${index}].productImpact`, productImpactState, {
                shouldDirty: true,
                shouldValidate: false,
              });
            }
          } catch (error) {
            // Silently handle errors if ref is not ready
          }
        }
      });
    };

    // Sync when accordion state changes (when user closes accordion)
    syncProductImpactToForm();

    // Also sync periodically to catch any changes (every 3 seconds)
    const intervalId = setInterval(syncProductImpactToForm, 3000);

    return () => {
      clearInterval(intervalId);
    };
  }, [productImpactActiveKeys, setValue]);

  // Sync product impact when accordion closes (when activeKey becomes null)
  useEffect(() => {
    const syncProductImpactOnClose = () => {
      Object.keys(productImpactActiveKeys).forEach((index) => {
        // If accordion is closed (activeKey is null), sync the data
        if (productImpactActiveKeys[index] === null) {
          const ref = bomProductImpactRefs.current[index];
          if (ref && typeof ref.getBomImpactLocalState === 'function') {
            try {
              const productImpactState = ref.getBomImpactLocalState();
              if (productImpactState) {
                setValue(`bomForm[${index}].productImpact`, productImpactState, {
                  shouldDirty: true,
                  shouldValidate: false,
                });
              }
            } catch (error) {
              // Silently handle errors if ref is not ready
            }
          }
        }
      });
    };

    syncProductImpactOnClose();
  }, [productImpactActiveKeys, setValue]);

  const onChangeAdditionalInfo = (e, i) => {
    const { value } = e.currentTarget;
    setAdditionalInfoCount((prev) => ({
      ...prev,
      [`bomForm[${i}].additionalInfo`]: value.length,
    }));
  };

  const onChangeDescCount = (e, i) => {
    const { value } = e.currentTarget;
    setDescCount((prev) => ({
      ...prev,
      [`bomForm[${i}].component_des`]: value.length,
    }));
  };

  const addNewBom = async () => {
    if (isValid) {
      await append({
        componentType: '',
        componentCode: '',
        component_des: '',
        supplier: '',
        size: '',
        sizeUnitOfMeasure: '',
        weight: '',
        weightUnitOfMeasure: '',
        quantity: '',
        quantityUnitOfMeasure: '',
        pricePerUnit: '',
        pricePerUnitCurrency: null,
        newPlacement: [],
        transport: null,
        quality: null,
        finished: null,
        bomComponentSubType: null,
        composition: [
          {
            percentage: null,
            composition: null,
          },
        ],
        additionalInfo: '',
        dynamicColumn: defaultDynamicColumns,
      });
      await clearErrors();
    } else {
      await trigger();
    }
  };

  const removeBomLib = async (item, i) => {
    removeSelectedBomComponent(item, i);
    disabledSubmitButton(fields.length === 1 && i === 0);
  };

  const handleSelectDynamic = (selectedOption, key, dynamicId, index) => {
    const existing = getValues(`bomForm[${index}].dynamicColumn`) || [];
    const updatedDynamic = cloneDeep(existing);

    const existingIndex = updatedDynamic.findIndex((col) => {
      const id = col.colId?._id || col._id;
      return id === dynamicId;
    });

    const fieldType = customAttributeBomList.find((f) => f._id === dynamicId)?.type;

    if (existingIndex > -1) {
      if (fieldType === 'text') {
        updatedDynamic[existingIndex].valueText = selectedOption;
      } else if (fieldType === 'Multi Dropdown') {
        updatedDynamic[existingIndex].valueId = selectedOption.map((opt) => ({
          _id: opt.value || opt._id,
          keyName: opt.label || opt.keyName,
        }));
        updatedDynamic[existingIndex].optionsValue = selectedOption;
      } else {
        updatedDynamic[existingIndex].valueId = selectedOption?.value || selectedOption;
        updatedDynamic[existingIndex].optionsValue = selectedOption;
      }
    } else {
      const newField = {
        colId: { _id: dynamicId },
      };

      if (fieldType === 'text') {
        newField.valueText = selectedOption;
      } else if (fieldType === 'Multi Dropdown') {
        newField.valueId = selectedOption.map((opt) => ({
          _id: opt.value || opt._id,
          keyName: opt.label || opt.keyName,
        }));
        newField.optionsValue = selectedOption;
      } else {
        newField.valueId = selectedOption?.value || selectedOption;
        newField.optionsValue = selectedOption;
      }
      updatedDynamic.push(newField);
    }

    setValue(`bomForm[${index}].dynamicColumn`, updatedDynamic, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  // Sub-BOM handlers
  const initializeSubBOMState = (index) => {
    const currentSubBomList = getValues(`bomForm[${index}].subBomList`) || [];
    if (!currentSubBomList || currentSubBomList.length === 0) {
      const defaultSubBom = [
        {
          isSave: false,
          error: false,
          isDefault: true,
          composition: [
            {
              percentage: null,
              composition: null,
            },
          ],
        },
      ];
      setValue(`bomForm[${index}].subBomList`, defaultSubBom, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
    if (!columnHeaders[index]) {
      const firstRowCompositionLength = currentSubBomList.length > 0 ? currentSubBomList[0]?.composition?.length || 1 : 1;
      const defaultHeaders = Array(firstRowCompositionLength).fill('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION');
      setColumnHeaders((prev) => ({
        ...prev,
        [index]: defaultHeaders,
      }));
    }
  };

  const handleOpenAccordion = (index) => {
    initializeSubBOMState(index);
    setActiveKeys((prev) => ({
      ...prev,
      [index]: prev[index] === '0' ? null : '0',
    }));
  };

  const toogleAddComposition = (e, bomIndex) => {
    e.preventDefault();
    const currentColumnHeader = columnHeaders[bomIndex] || ['BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION'];
    if (currentColumnHeader?.length === 5) {
      toasterMsg(t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.MAX_COLUMNS'), 'danger');
      return;
    }
    const currentSubBomList = getValues(`bomForm[${bomIndex}].subBomList`) || [];
    const copyState = cloneDeep(currentSubBomList);
    copyState.forEach((row, rowIndex) => {
      const column = [...row.composition];
      column.push({
        percentage: null,
        composition: '',
      });
      const path = commonPath(rowIndex, 'composition').COMMON_PATH;
      set(copyState, path, column);
    });
    setColumnHeaders((prev) => ({
      ...prev,
      [bomIndex]: [...currentColumnHeader, 'BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION'],
    }));
    // Update form state directly
    setValue(`bomForm[${bomIndex}].subBomList`, copyState, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  const toogleDeleteComposition = (e, bomIndex, columnIndex) => {
    e.preventDefault();
    const currentSubBomList = getValues(`bomForm[${bomIndex}].subBomList`) || [];
    const copyState = cloneDeep(currentSubBomList);
    copyState.forEach((row, rowIndex) => {
      const column = [...row.composition];
      if (columnIndex >= 0 && columnIndex < column.length) {
        column.splice(columnIndex, 1);
      }
      const path = commonPath(rowIndex, 'composition').COMMON_PATH;
      set(copyState, path, column);
    });
    setColumnHeaders((prev) => {
      const currentColumnHeader = prev[bomIndex] || ['BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION'];
      const indexToRemove = currentColumnHeader.findIndex((item) => item === 'BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION');
      if (indexToRemove === -1) {
        return prev;
      }
      const newHeaders = [...currentColumnHeader];
      newHeaders.splice(columnIndex, 1);
      return {
        ...prev,
        [bomIndex]: newHeaders,
      };
    });
    // Update form state directly
    setValue(`bomForm[${bomIndex}].subBomList`, copyState, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <>
      <div className="d-flex justify-content-end p-1">
        <div className="d-flex align-items-center">
          {selectedType && selectedType.value !== 'amendment' && !suggestionEditMode && (
            <button
              type="button"
              onClick={() => {
                addNewBom();
              }}
              title={t('BOM_TYPE_FORM.ADD_NEW')}
              className="btn btn-default"
            >
              {t('BOM_TYPE_FORM.ADD_NEW')}
            </button>
          )}
        </div>
      </div>
      {fields.length > 0 &&
        fields.map((formItem, index) => {
          return (
            <div
              key={formItem.id || formItem._id || JSON.stringify(formItem)}
              className={
                formItem.status === 'Approved' || formItem.status === 'Deleted' ? 'disabled d-flex justify-content-between' : 'd-flex justify-content-between'
              }
            >
              <div className={formItem.status === 'Approved' ? 'disabled suggestion-form mt-2' : 'suggestion-form mt-2'}>
                <Row>
                  {formItem.productName && (
                    <Col lg="3">
                      <div className={`common-input-control ${formItem.productName ? 'disabled' : ''}`}>
                        <p className="field-name">
                          {t('BOM_TYPE_FORM.REFERENCE_CODE')}
                          <span className="asterisk">*</span>
                        </p>
                        <input
                          type="text"
                          tabIndex="-1"
                          name={`bomForm[${index}].productName`}
                          className="form-control"
                          {...register(`bomForm[${index}].productName`, {
                            required: true,
                            validate: (value) => !!value.trim() || 'no whitespaces.',
                          })}
                          defaultValue={formItem.productName}
                        />
                      </div>
                    </Col>
                  )}
                  <Col lg={3}>
                    <div className={`common-input-control  ${selectedType?.value === 'amendment' ? 'disabled' : ''} `}>
                      <p className="field-name">
                        {t('BOM_TYPE_FORM.COMPONENT_CODE')}
                        <span className="asterisk">*</span>
                      </p>
                      <input
                        type="text"
                        tabIndex="-1"
                        autoComplete="off"
                        name={`bomForm[${index}].componentCode`}
                        className="form-control"
                        {...register(`bomForm[${index}].componentCode`, {
                          required: true,
                          setValueAs: (value) => value?.trim(),
                        })}
                        defaultValue={formItem.componentCode}
                      />
                      {errors?.bomForm?.[index]?.componentCode && <small className="error-message">{t('BOM_TYPE_FORM.COMPONENET_CODE_REQUIRED')}</small>}
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="common-input-control ">
                      <p className="field-name">{t('BOM_TYPE_FORM.COMPONENT_DESCRIPTION')}</p>
                      <input
                        type="text"
                        name={`bomForm[${index}].component_des`}
                        autoComplete="off"
                        className="form-control"
                        defaultValue={formItem.component_des}
                        {...register(`bomForm[${index}].component_des`, {
                          required: false,
                          maxLength: { value: 200 },
                          setValueAs: (value) => value?.trim(),
                        })}
                        onChange={(e) => {
                          onChangeDescCount(e, index);
                        }}
                      />
                      <div className="d-flex w-100">
                        {descCount[`bomForm[${index}].component_des`] > 200 && (
                          <small className="error-message text-left">{t('BOM_TYPE_FORM.200_CHARACTER_ALLOWED')}</small>
                        )}

                        <div className="text-right w-100">
                          <span className="text-success">
                            {descCount[`bomForm[${index}].component_des`] === undefined && descCount[`bomForm[${index}].component_des`] !== 0
                              ? `${formItem.component_des.length}/200`
                              : `${descCount[`bomForm[${index}].component_des`]}/200`}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg="3">
                    <div className={`common-react-select flex-fill ${formItem.supplier || selectedType?.value === 'amendment' ? 'disabled' : ''} `}>
                      <p className="field-name">{t('BOM_TYPE_FORM.SUPPLIER')}</p>
                      <Select
                        name={`bomForm[${index}].supplier`}
                        {...register(`bomForm[${index}].supplier`, {
                          required: false,
                        })}
                        options={supplierOptions}
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option._id}`}
                        className="common-select"
                        classNamePrefix="common-select"
                        defaultValue={formItem.supplier}
                        onChange={(val) => {
                          setValue(`bomForm[${index}].supplier`, val, {
                            shouldValidate: true,
                          });
                          return { value: val };
                        }}
                        placeholder={t('BOM_TYPE_FORM.SELECT_SUPLIER')}
                      />
                      {errors.bomForm?.[index]?.supplier && <small className="error-message">{t('BOM_TYPE_FORM.SUPPLIER_IS_REQUIRED')}</small>}
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="common-react-select">
                      <p className="field-name">{t('BOM_TYPE_FORM.TRANSPORT')}</p>
                      <Select
                        {...register(`bomForm[${index}].transport`)}
                        name={`bomForm[${index}].transport`}
                        options={transportArray}
                        getOptionLabel={(option) => `${option?.label}`}
                        getOptionValue={(option) => `${option?.name}`}
                        defaultValue={formItem?.transport}
                        onChange={(val) => {
                          setValue(`bomForm[${index}].transport`, val);
                          return { value: val };
                        }}
                        className="common-select"
                        classNamePrefix="common-select"
                        placeholder={t('BOM_TYPE_FORM.TRANSPORT')}
                      />
                    </div>
                  </Col>
                  <Col lg="3">
                    <div className={`common-react-select flex-fill  ${selectedType?.value === 'amendment' ? 'disabled' : ''} `}>
                      <p className="field-name">
                        {t('BOM_TYPE_FORM.COMPONENT_TYPE')}
                        <span className="asterisk">*</span>
                      </p>
                      <Select
                        options={componentType}
                        tabIndex="-1"
                        name={`bomForm[${index}].componentType`}
                        {...register(`bomForm[${index}].componentType`, {
                          required: true,
                        })}
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option._id}`}
                        defaultValue={formItem.componentType}
                        onChange={(val) => {
                          setValue(`bomForm[${index}].componentType`, val, {
                            shouldValidate: true,
                          });
                          return { value: val };
                        }}
                        className="common-select"
                        classNamePrefix="common-select"
                        placeholder={t('BOM_TYPE_FORM.SELECT_COMPONENET_TYPE')}
                      />
                      {errors.bomForm?.[index]?.componentType && <small className="error-message">{t('BOM_TYPE_FORM.COMPONENET_TYPE_REQUIRED')}</small>}
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="common-react-select">
                      <p className="field-name">{t('BOM_TYPE_FORM.BOM_COMP_SUB_TYPE')}</p>
                      <Select
                        {...register(`bomForm[${index}].bomComponentSubType`)}
                        name={`bomForm[${index}].bomComponentSubType`}
                        options={bomSubComponentOptions?.filter(
                          (ele) => ele?.bomTypeId === selectedBomType?._id && ele?.componentTypeId === getValues(`bomForm[${index}].componentType`)?._id,
                        )} //  bomComponentSubType Options
                        getOptionLabel={(option) => `${option?.name}`}
                        getOptionValue={(option) => `${option?._id}`}
                        defaultValue={formItem?.bomComponentSubType}
                        onChange={(val) => {
                          setValue(`bomForm[${index}].bomComponentSubType`, val);
                          return { value: val };
                        }}
                        className="common-select"
                        classNamePrefix="common-select"
                        placeholder={t('BOM_TYPE_FORM.BOM_COMP_SUB_TYPE')}
                      />
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="d-flex">
                      <div className="common-input-control">
                        <p className="field-name">{t('BOM_TYPE_FORM.SIZE')}</p>
                        <input
                          type="text"
                          autoComplete="off"
                          name={`bomForm[${index}].size`}
                          defaultValue={formItem.size}
                          className="form-control"
                          {...register(`bomForm[${index}].size`, {
                            required: false,
                            setValueAs: (value) => value?.trim(),
                          })}
                        />
                      </div>
                      <div className="inline-unit">
                        <div className="common-react-select">
                          <Select
                            {...register(`bomForm[${index}].sizeUnitOfMeasure`)}
                            name={`bomForm[${index}].sizeUnitOfMeasure`}
                            options={unitList}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            defaultValue={formItem.sizeUnitOfMeasure}
                            onChange={(val) => {
                              setValue(`bomForm[${index}].sizeUnitOfMeasure`, val, {
                                shouldValidate: true,
                              });
                              return { value: val };
                            }}
                            className="common-select"
                            classNamePrefix="common-select"
                            placeholder={t('BOM_TYPE_FORM.UOM')}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="d-flex">
                      <div className="common-input-control">
                        <p className="field-name">{t('BOM_TYPE_FORM.WEIGHT')}</p>
                        <input
                          type="text"
                          autoComplete="off"
                          name={`bomForm[${index}].weight`}
                          className="form-control"
                          defaultValue={formItem.weight}
                          {...register(`bomForm[${index}].weight`, {
                            required: false,
                            setValueAs: (value) => value?.trim(),
                          })}
                        />
                      </div>
                      <div className="inline-unit">
                        <div className="common-react-select">
                          <Select
                            {...register(`bomForm[${index}].weightUnitOfMeasure`, {
                              required: false,
                            })}
                            name={`bomForm[${index}].weightUnitOfMeasure`}
                            options={unitList}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            defaultValue={formItem.weightUnitOfMeasure}
                            onChange={(val) => {
                              setValue(`bomForm[${index}].weightUnitOfMeasure`, val, {
                                shouldValidate: true,
                              });
                              return { value: val };
                            }}
                            className="common-select"
                            classNamePrefix="common-select"
                            placeholder={t('BOM_TYPE_FORM.UOM')}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="d-flex">
                      <div className="common-input-control">
                        <p className="field-name">{t('BOM_TYPE_FORM.QUANTITY')}</p>
                        <input
                          type="text"
                          autoComplete="off"
                          label={t('BOM_TYPE_FORM.QUANTITY')}
                          name={`bomForm[${index}].quantity`}
                          {...register(`bomForm[${index}].quantity`, {
                            required: false,
                            setValueAs: (value) => value?.trim(),
                          })}
                          placeholder={t('BOM_TYPE_FORM.QUANTITIES')}
                          defaultValue={formItem.quantity}
                          className="form-control"
                        />
                      </div>
                      <div className="inline-unit">
                        <div className="common-react-select">
                          <Select
                            {...register(`bomForm[${index}].quantityUnitOfMeasure`, {
                              required: false,
                            })}
                            name={`bomForm[${index}].quantityUnitOfMeasure`}
                            options={unitList}
                            getOptionLabel={(option) => `${option?.name}`}
                            getOptionValue={(option) => `${option?._id}`}
                            defaultValue={formItem?.quantityUnitOfMeasure}
                            onChange={(val) => {
                              setValue(`bomForm[${index}].quantityUnitOfMeasure`, val, {
                                shouldValidate: true,
                              });
                              return { value: val };
                            }}
                            className="common-select"
                            classNamePrefix="common-select"
                            placeholder={t('BOM_TYPE_FORM.UOMS')}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="d-flex">
                      <div className="common-input-control">
                        <p className="field-name">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PRICE_PER_UNIT')}</p>
                        <input
                          type="text"
                          autoComplete="off"
                          name={`bomForm[${index}].pricePerUnit`}
                          {...register(`bomForm[${index}].pricePerUnit`, {
                            required: false,
                            pattern: {
                              value: /^[0-9]+(\.[0-9]+)?$/,
                              message: t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.INVALID_NUMBER'),
                            },
                            setValueAs: (value) => value?.trim(),
                          })}
                          placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PRICE_PER_UNIT')}
                          defaultValue={formItem?.pricePerUnit}
                          className="form-control"
                          onKeyPress={(e) => {
                            const charCode = e.which ? e.which : e.keyCode;
                            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                      <div className="inline-unit">
                        <div className="common-react-select">
                          <Select
                            {...register(`bomForm[${index}].pricePerUnitCurrency`, {
                              required: false,
                            })}
                            name={`bomForm[${index}].pricePerUnitCurrency`}
                            options={currencyOptions}
                            getOptionLabel={(option) => `${option.label}`}
                            getOptionValue={(option) => `${option.value}`}
                            value={(() => {
                              const currentValue = watch(`bomForm[${index}].pricePerUnitCurrency`) || formItem?.pricePerUnitCurrency;
                              if (!currentValue) return null;
                              return currencyOptions.find((option) => option.value === currentValue?.value || option.value === currentValue) || null;
                            })()}
                            onChange={(val) => {
                              setValue(`bomForm[${index}].pricePerUnitCurrency`, val, {
                                shouldValidate: true,
                              });
                            }}
                            className="common-select"
                            classNamePrefix="common-select"
                            placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.CURRENCY')}
                            isClearable
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="common-react-select">
                      <p className="field-name">{t('BOM_TYPE_FORM.FINISH')}</p>
                      <Select
                        {...register(`bomForm[${index}].finished`)}
                        name={`bomForm[${index}].finished`}
                        options={finishedOptions}
                        getOptionLabel={(option) => `${option?.name}`}
                        getOptionValue={(option) => `${option?._id}`}
                        defaultValue={formItem?.finished}
                        onChange={(val) => {
                          setValue(`bomForm[${index}].finished`, val);
                          return { value: val };
                        }}
                        className="common-select"
                        classNamePrefix="common-select"
                        placeholder={t('BOM_TYPE_FORM.FINISH')}
                      />
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="common-react-select">
                      <p className="field-name">{t('BOM_TYPE_FORM.PLACEMENT')}</p>
                      <Controller
                        name={`bomForm[${index}].newPlacement`}
                        control={control}
                        defaultValue={formItem?.newPlacement?.map((item) => item._id) || []}
                        // rules={{
                        //   required: t("BOM_TYPE_FORM.ERRORS.PLACEMENT_REQUIRED", "Placement is required."),
                        // }}
                        render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => {
                          const selectedOptions = Array.isArray(value)
                            ? value.map((re) => ({
                                value: re?._id || re?.value,
                                label: re?.name || re?.label,
                              }))
                            : [];

                          return (
                            <MultiSelect
                              options={multiPlacementOptions}
                              value={selectedOptions}
                              onChange={onChange}
                              onBlur={onBlur}
                              labelledBy={t('BOM_TYPE_FORM.PLACEMENT_LABEL', 'Select Placement')}
                              className="product-custom-multiselect common-new-multiselect"
                              overrideStrings={{
                                selectSomeItems: t('BOM_TYPE_FORM.SELECT_PLACEMENT_PLACEHOLDER', 'Select...'),
                                allItemsAreSelected: t('BOM_TYPE_FORM.ALL_PLACEMENTS_SELECTED', 'All items are selected.'),
                                selectAll: t('BOM_TYPE_FORM.SELECT_ALL_PLACEMENTS', 'Select All'),
                                search: t('BOM_TYPE_FORM.SEARCH_PLACEMENTS', 'Search'),
                              }}
                              hasSelectAll={false}
                            />
                          );
                        }}
                      />
                    </div>
                  </Col>
                  <Composition
                    compositionListObj={compositionList}
                    nestIndex={index}
                    {...{ control, register, setValue }}
                    onCompositionChange={handleCompositionChange}
                  />
                  {customAttributeBomList
                    ?.filter((ele) => ele?.bomTypeID === selectedBomType?._id)
                    ?.map((ele) => {
                      const selectedItem = bomForm?.[index]?.dynamicColumn?.find((eleDyna) => {
                        const targetId = eleDyna?.colId?._id || eleDyna?._id;
                        return targetId === ele._id;
                      });
                      if (ele.type === 'dropdown' && ele.isActive) {
                        return (
                          <Col md={2} className="add-form" key={ele?._id}>
                            <div className="common-react-select">
                              <p className="field-name">{ele?.keyName}</p>
                              <Select
                                name="customValue"
                                options={ele?.options?.filter((option) => option?.isActive)}
                                value={ele?.options
                                  ?.filter((option) => option?.isActive)
                                  ?.find((option) =>
                                    selectedItem?.valueId ? selectedItem?.valueId?._id === option?._id : option._id === selectedItem?.optionsValue,
                                  )}
                                onChange={(e) => handleSelectDynamic(e, 'optionsValue', ele?._id, index)}
                                getOptionLabel={(option) => option?.keyName}
                                getOptionValue={(option) => option?._id}
                                className="common-select"
                                classNamePrefix="common-select"
                                isClearable
                                placeholder={ele?.keyName}
                              />
                            </div>
                          </Col>
                        );
                      }

                      if (ele.type === 'text' && ele.isActive) {
                        const maxlen = ele.textFieldConfig?.charLimit;
                        const isExceedable = ele.textFieldConfig?.isExceedable;
                        const isHightlight = ele.textFieldConfig?.isHighlightable;
                        const shouldHighlight = isExceedable && isHightlight && selectedItem?.valueText?.length > maxlen;

                        return (
                          <Col key={ele._id} md={2}>
                            <div className="common-input-control">
                              <p className="field-name">{ele.keyName}</p>
                              <input
                                maxLength={maxlen}
                                style={shouldHighlight ? { color: 'red' } : {}}
                                type="text"
                                value={selectedItem?.valueText || ''}
                                onChange={(e) => handleSelectDynamic(e.target.value, 'valueText', ele._id, index)}
                                className="form-control"
                              />
                            </div>
                          </Col>
                        );
                      }
                      if (ele.type === 'Multi Dropdown' && ele.isActive) {
                        return (
                          <Col md={2} className="add-form" key={ele?._id}>
                            <div className="common-react-select">
                              <p className="field-name">{ele?.keyName}</p>
                              <MultiSelect
                                options={ele?.options
                                  ?.filter((opt) => opt?.isActive)
                                  .map((opt) => ({
                                    label: opt.keyName,
                                    value: opt._id,
                                  }))}
                                value={(() => {
                                  if (Array.isArray(selectedItem?.optionsValue)) {
                                    return selectedItem.optionsValue.map((opt) => ({
                                      label: opt.label || opt.keyName || '',
                                      value: opt.value || opt._id || '',
                                    }));
                                  }
                                  if (Array.isArray(selectedItem?.valueId)) {
                                    return selectedItem.valueId.map((opt) => ({
                                      label: opt.keyName || '',
                                      value: opt._id || '',
                                    }));
                                  }
                                  return [];
                                })()}
                                onChange={(e) => handleSelectDynamic(e, 'optionsValue', ele._id, index)}
                                labelledBy={ele?.keyName}
                                hasSelectAll
                                className="product-custom-multiselect common-new-multiselect w-100"
                              />
                            </div>
                          </Col>
                        );
                      }

                      return null;
                    })}

                  <Col lg={9}>
                    <FormGroup>
                      <div className="common-input-control">
                        <p className="field-name">{t('BOM_TYPE_FORM.ADDITIONAL_INFO')}</p>
                        <input
                          type="text"
                          autoComplete="off"
                          name={`bomForm[${index}].additionalInfo`}
                          defaultValue={formItem?.additionalInfo}
                          maxLength={200}
                          className="form-control"
                          {...register(`bomForm[${index}].additionalInfo`, {
                            required: false,
                            maxLength: { value: 200 },
                            setValueAs: (value) => value?.trim(),
                          })}
                          onChange={(e) => {
                            onChangeAdditionalInfo(e, index);
                          }}
                        />

                        <div className="d-flex w-100">
                          {additionalInfoCount[`bomForm[${index}].additionalInfo`] > 200 && (
                            <small className="error-message text-left">{t('BOM_TYPE_FORM.200_CHARACTER_ALLOWED')}</small>
                          )}

                          <div className="text-right w-100">
                            <span className="text-success">
                              {additionalInfoCount[`bomForm[${index}].additionalInfo`] === undefined &&
                              additionalInfoCount[`bomForm[${index}].additionalInfo`] !== 0
                                ? `${formItem?.additionalInfo?.length}/200`
                                : `${additionalInfoCount[`bomForm[${index}].additionalInfo`]}/200`}
                            </span>
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <div className="collapse-card add-bom-accordion mt-3">
                  <Accordion activeKey={activeKeys[index] || null}>
                    <Card className="bom-add-card">
                      <Card.Header>
                        <div className="d-flex align-items-center">
                          <label className="switch-text mb-0 ml-16 f-16 text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUB_BOM')}</label>
                        </div>

                        <Accordion.Toggle className="btn-toggle accordion-toggle-icon" as={Button} variant="link" onClick={() => handleOpenAccordion(index)}>
                          <CustomToggle eventKey="0" />
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse className="edit-collapse" eventKey="0">
                        <Card.Body className="accordion-new-body">
                          <div className="table-responsive">
                            <Table className="table custom-table sub-bom-table layout-fixed font-13" bordered>
                              <thead>
                                <tr>
                                  <th className="w-50px" />
                                  <th className="w-120px text-left">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.IMAGE')}</th>
                                  <th className="w-150px last-fix-col">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_CODE')}</th>
                                  <th className="w-200px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_DESCRIPTION')}</th>
                                  <th className="w-150px">
                                    <p className="field-lbl mb-0 asterisk-req-green">
                                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUPLIER')}
                                      <span>*</span>
                                    </p>
                                  </th>
                                  <th className="w-150px">
                                    <p className="field-lbl mb-0 asterisk-req-green">
                                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_TYPE')}
                                      <span>*</span>
                                    </p>
                                  </th>
                                  <th className="w-150px">
                                    <p className="field-lbl mb-0 asterisk-req-green">
                                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUB_TYPE')}
                                      <span>*</span>
                                    </p>
                                  </th>
                                  <th className="w-200px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SIZE/UOM')}</th>
                                  <th className="w-200px">
                                    <p className="field-lbl mb-0 asterisk-req-green">
                                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.WEIGHT/UOM')}
                                      <span>*</span>
                                    </p>
                                  </th>
                                  <th className="w-200px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.QUANTITY/UOM')}</th>
                                  <th className="w-120px">
                                    <p className="field-lbl mb-0 asterisk-req-green">
                                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.FINISH')}
                                      <span>*</span>
                                    </p>
                                  </th>
                                  {(() => {
                                    const currentColumnHeaders = columnHeaders[index] || ['BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION'];
                                    const headersLength = currentColumnHeaders.length;
                                    return currentColumnHeaders?.map((header, headerIndex) => (
                                      <th key={headerIndex} className="w-200px">
                                        <div className="d-inline-flex align-items-center">
                                          <p className="field-lbl mb-0 asterisk-req-green ">
                                            {t(header)}
                                            <span>*</span>
                                          </p>
                                          {headerIndex === headersLength - 1 && (
                                            <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                                              <button
                                                className="btn ml-2 add-btn-subbom"
                                                onClick={(e) => toogleAddComposition(e, index)}
                                                type="button"
                                                aria-label={t('DEVLOPMENT_ORDER.BOM.BOM_LISTS.ADD')}
                                              >
                                                <i className="icon-Add f-20" />
                                              </button>
                                            </CustomTooltip>
                                          )}

                                          {headersLength > 1 && (
                                            <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                                              <button
                                                className="btn ml-2 add-btn-subbom"
                                                type="button"
                                                aria-label={t('DEVLOPMENT_ORDER.BOM.BOM_LISTS.ADD')}
                                                onClick={(e) => toogleDeleteComposition(e, index, headerIndex)}
                                              >
                                                {' '}
                                                <i className="icon-Delete f-20" />
                                              </button>
                                            </CustomTooltip>
                                          )}
                                        </div>
                                      </th>
                                    ));
                                  })()}
                                  <th className="w-80px" />
                                </tr>
                              </thead>
                              {(() => {
                                const watchedSubBomList = bomForm?.[index]?.subBomList || watch(`bomForm[${index}].subBomList`) || formItem?.subBomList || [];
                                const currentSubBomList = watchedSubBomList;
                                const currentBomDocumentState = { cardList: currentSubBomList };

                                return currentSubBomList.map((data, subBomIndex) => (
                                  <BomSubType
                                    key={data?._id || subBomIndex}
                                    dataValue={data}
                                    dataIndex={subBomIndex}
                                    bomDocumentState={currentBomDocumentState}
                                    setBomDocumentState={(stateUpdater) => {
                                      const currentFormData = getValues(`bomForm[${index}].subBomList`) || [];
                                      const currentState = { cardList: currentFormData };
                                      const newState = typeof stateUpdater === 'function' ? stateUpdater(currentState) : stateUpdater;
                                      if (newState?.cardList) {
                                        const updatedSubBomList = [...newState.cardList];
                                        setValue(`bomForm[${index}].subBomList`, updatedSubBomList, {
                                          shouldDirty: true,
                                          shouldValidate: true,
                                        });

                                        if (updatedSubBomList[subBomIndex]) {
                                          setValue(`bomForm[${index}].subBomList[${subBomIndex}]`, updatedSubBomList[subBomIndex], {
                                            shouldDirty: true,
                                            shouldValidate: true,
                                          });
                                        }
                                      }
                                    }}
                                    setCoumnHeader={(newHeaders) => {
                                      setColumnHeaders((prev) => ({
                                        ...prev,
                                        [index]: newHeaders,
                                      }));
                                    }}
                                    columnHeader={columnHeaders[index] || ['BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION']}
                                    id={null}
                                    setBomDeletedData={(newDeletedData) => {
                                      setBomDeletedData((prev) => ({
                                        ...prev,
                                        [index]: newDeletedData,
                                      }));
                                    }}
                                    compositionErrors={compositionErrors[index] || []}
                                    setCompositionErrors={(newErrors) => {
                                      setCompositionErrors((prev) => ({
                                        ...prev,
                                        [index]: newErrors,
                                      }));
                                    }}
                                    BOMId={selectedBomType?._id}
                                    isSuggestionMode
                                  />
                                ));
                              })()}
                            </Table>
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
                {/* Sub-BOM Accordion */}
                <div className="collapse-card add-bom-accordion mt-3">
                  <Accordion activeKey={productImpactActiveKeys[index] || null}>
                    <Card className="bom-add-card">
                      <Card.Header>
                        <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.BOM_PRODUCT_IMPACT')}</span>
                        <Accordion.Toggle
                          className="btn-toggle accordion-toggle-icon"
                          as={Button}
                          variant="link"
                          onClick={() => setProductImpactActiveKeys((prev) => ({ ...prev, [index]: prev[index] === '0' ? null : '0' }))}
                        >
                          <CustomToggle eventKey="0" />
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body className="common-border-top">
                          <BomProductImpact
                            ref={(el) => {
                              if (el) bomProductImpactRefs.current[index] = el;
                            }}
                            combinedDataArray={[]}
                            id={null}
                            isCombinationSupplierActive={false}
                            BomSuppliers={formItem?.supplier ? [formItem.supplier] : []}
                            isFromLibrary={false}
                            bomDetailsBasedOnId={formItem?.productImpact ? { productImpact: formItem.productImpact } : null}
                            referenceSupp={suppliers || supplierOptions || []}
                            bomSubType={getValues(`bomForm[${index}].componentType`)}
                            bomTypeId={selectedBomType?._id}
                            fromBomExpand={false}
                            isSuggestionMode
                          />
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
              </div>

              <div className="mt-2">
                {!suggestionEditMode && !fromLibrary && (
                  <button
                    disabled={selectedType?.value !== 'amendment' && index === 0}
                    title={t('BOM_TYPE_FORM.DELETE')}
                    aria-label={t('BOM_TYPE_FORM.DELETE')}
                    type="button"
                    onClick={() => removeBomLib(formItem, index)}
                    className="btn btn-outline sm"
                  >
                    <span className="icon-Delete " />
                  </button>
                )}
              </div>
            </div>
          );
        })}
    </>
  );
}

const mapStateToProps = ({ SupplierSuggestion, UserDetails, BOMConfigDetails }) => {
  const { section, compositionComponent, units, supplierData, placementOptions, finishedOptions, bomSubComponentOptions } = SupplierSuggestion;
  const { userInfo } = UserDetails;
  const { suppliers } = BOMConfigDetails;
  return {
    sectionListFromReducer: section,
    compositionFromReducer: compositionComponent,
    unitsFromReducer: units,
    supplierFromReducer: supplierData,
    placementOptions,
    finishedOptions,
    bomSubComponentOptions,
    userInfo,
    suppliers,
  };
};

const mapStateToDispatch = {
  getPlacementOptions,
  getFinishedOptions,
  getAllBOMComponentOptions,
  fetchBomReferenceType,
  fetchBomLibarayUnitOfMeasure,
  fetchBomLibarayComposition,
  getCompositionProcessDetails: masterAction.getCompositionProcessDetails,
};

export default connect(mapStateToProps, mapStateToDispatch)(BomTypeForm);
